import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BreadcrumbItem } from '../../shared/modules/gains-breadcrumb/gains-breadcrumb.component';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private readonly _breadcrumbs = new BehaviorSubject<BreadcrumbItem[]>([]);
  breadcrumbs = this._breadcrumbs.asObservable();

  setBreadcrumbs(items: BreadcrumbItem[]) {
    this._breadcrumbs.next(items);
  }

  getBreadcrumbs(): BreadcrumbItem[] {
    return this._breadcrumbs.getValue();
  }
}
